module.exports = __webpack_public_path__ + "static/media/r5.7e5b1a4b.png";